module.exports = __webpack_public_path__ + "img/slide01.8e0fb49a.png";